import { Navigate, useParams } from "react-router-dom";

/** Legacy preview URL redirects to the public runtime. */
const ClientViewPreviewPage = () => {
  const { slug } = useParams();
  return <Navigate to={`/v/${slug}`} replace />;
};

export default ClientViewPreviewPage;
